import { useEffect, useState } from 'react'

export const useMediaQuery = (query: string) => {
  const [match, setMatch] = useState(false)

  useEffect(() => {
    let active = true

    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
      return undefined
    }

    const queryList = matchMedia(query)
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches)
      }
    }
    if (queryList?.addEventListener) {
      updateMatch()
      queryList.addEventListener('change', updateMatch, { passive: true })
    } else {
      queryList.addListener(updateMatch)
    }
    return () => {
      active = false
      if (queryList?.removeEventListener) {
        queryList.removeEventListener('change', updateMatch)
      } else {
        queryList.removeListener(updateMatch)
      }
    }
  }, [query])

  return match
}
